import React from 'react'
import styled from 'styled-components'

import AmericanExpressIcon from '../img/credit_card_logos/american-express.inline.svg'
import DiscoverIcon from '../img/credit_card_logos/discover.inline.svg'
import MastercardIcon from '../img/credit_card_logos/mastercard.inline.svg'
import VisaIcon from '../img/credit_card_logos/visa.inline.svg'

const iconComponentFor = (
  ccType: string,
): React.FC<React.SVGAttributes<SVGElement>> | undefined => {
  switch (ccType) {
    case 'AE':
    case 'American Express':
    case 'AMERICAN EXPRESS':
      return AmericanExpressIcon
    case 'DC':
    case 'DI':
    case 'Discover':
    case 'DISCOVER':
      return DiscoverIcon
    case 'MC':
    case 'Mastercard':
    case 'MasterCard':
    case 'MASTERCARD':
      return MastercardIcon
    case 'VI':
    case 'Visa':
    case 'VISA':
      return VisaIcon
    default:
      return undefined
  }
}

const StyledCreditCardLogo = styled.svg`
  display: inline-block;
  height: 1em;
  width: auto;
  vertical-align: -0.125em;
`

export interface CreditCardLogoProps {
  ccType: string
  className?: string
}

const CreditCardLogo: React.VFC<CreditCardLogoProps> = ({ ccType, className }) => {
  const IconComponent = iconComponentFor(ccType)
  return IconComponent ? <StyledCreditCardLogo as={IconComponent} className={className} /> : null
}

export default CreditCardLogo
